export default "__VITE_ASSET__1ef52aec__"